import styled from "styled-components";

export const Section = styled.section`
  padding: 120px 0;
`;

export const Grid = styled.div`
  max-width: 1650px;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
`;

export const CardWrapper = styled.div`
  position: relative;
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ReservedLeaderSlot = styled.div`
  width: 100%;
  min-width: 0;
  min-height: clamp(260px, 22vw, 300px);
  visibility: hidden;
  pointer-events: none;

  @media (max-width: 1100px) {
    display: none;
  }
`;

export const Portrait = styled.img`
  width: auto;
  max-width: 100%;
  height: clamp(150px, 14vw, 186px);
  object-fit: contain;
  display: block;
  margin: auto;
`;

export const InfoCard = styled.div`
  margin-top: -2px;
  background: #1b386b;
  border-radius: 60px;
  padding: 20px 15px;
  text-align: center;
  color: white;
  width: min(320px, 100%);
  -webkit-box-shadow: 2px 16px 22px 0px rgba(27, 56, 107, 0.55);
  box-shadow: 2px 16px 22px 0px rgba(27, 56, 107, 0.55);
`;

export const Name = styled.h3`
  font-size: clamp(15px, 1.3vw, 18px);
  font-weight: 700;
  overflow-wrap: anywhere;
`;

export const Designation = styled.p`
  font-size: clamp(12px, 1vw, 14px);
  overflow-wrap: anywhere;
`;
